module.exports = __webpack_public_path__ + "img/E307.bd6d2e05.svg";